declare let DRIFT_ELECTRON_ENVIRONMENT: string

export const isBrowser = typeof window !== 'undefined'

const hasNodeEnv = (env: string) => DRIFT_ELECTRON_ENVIRONMENT === env

const hasWindowEnv = (env: string) => isBrowser && window.__ENV__ === env

export const isEU = isBrowser && window.DRIFT_REGION === 'EU'
export const isProduction = isBrowser ? hasWindowEnv('PRODUCTION') : hasNodeEnv('production')
export const isQa = isBrowser ? hasWindowEnv('MASTER') : hasNodeEnv('qa')
export const environmentString = isProduction ? 'prod' : isQa ? 'qa' : 'dev'
export const isDev = environmentString === 'dev'